<template>
    <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
        <div v-show="show" class="inline-block align-bottom bg-white rounded-lg pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full md:max-w-md" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <div>
                <div :class="`mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-${$root.theme}-100`">
                    <svg :class="`h-8 w-8 text-${$root.theme}-600`" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                </div>
                <div class="mt-2">
                    <h3 class="text-lg mb-4 leading-6 font-medium text-gray-900 text-center" id="modal-headline">
                        First Payment Reduction
                    </h3>
                </div>
                <div class="px-5 pt-4 pb-1 border-t border-gray-200">
                    <p class="mb-2 font-medium text-sm">
                        Your first payment may be reduced by up to ${{ pdoConfig?.dollar_amount_off ?? '0' }} or {{ (pdoConfig?.percent_off ?? 0) * 100 }}%,
                        depending on the plan. The deferred amount will be added to the end of your arrangement.
                    </p>

                    <p class="mb-2 font-medium text-sm">Note: This option is not available for all offers or one-time payments.</p>
                    <p class="mb-4 font-medium text-sm">Would you like to proceed?</p>

                    <div class="flex flex-col md:flex-row-reverse justify-between space-y-2 md:space-y-0">
                        <button type="button"
                            @click="$emit('confirm')"
                            :class="{[`text-white px-3 text-xs py-2 md:ml-1 border border-transparent shadow-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 bg-${$root.theme}-300 hover:bg-${$root.theme}-400 focus:ring-${$root.theme}-200`]: true}">
                            Confirm
                        </button>
                        <button type="button"
                            @click="decline"
                            :class="{[`text-black px-3 text-xs py-2 md:mr-1 border border-transparent shadow-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 bg-gray-300 hover:bg-gray-400 focus:ring-gray-200`]: true}">
                            Decline
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import Mixins from '../../mixins'

    export default {
        props: ['show', 'pdoConfig'],

        mixins: [Mixins],

        methods: {
            decline() {
                this.gtagEvent(`pdo-declined:offers-page:confirmed`);

                this.$emit('decline');
            }
        }
    }
</script>
